'use es6';

import { Record } from 'immutable';
import { LearningMaterialTypes } from '../constants/ContentConstants';
export default Record({
  id: undefined,
  language: undefined,
  targetUrl: undefined,
  title: undefined,
  type: LearningMaterialTypes.OTHER
}, 'LearningMaterial');